<template>
    <PageHeader :title="t('withdraw.title')" />
    <div class="page-wrapper" style="padding-top: calc(50px * 1.1)!important;">
        <div class="withdrawal-container desktop-container">
            <div class="method-section">
                <div class="section-title">
                    <span class="title-text">{{ t('withdraw.method') }}</span>
                    <span class="title-subtitle">{{ t('withdraw.methodSubtitle') }}</span>
                </div>
                <div class="method-tabs">
                    <div class="method-tab" :class="{ 'active': selectedMethod === method.id }" v-for="method in currentWithdrawMethod" :key="method.id" @click="selectMethod(method.id)">
                        <div class="tab-content">
                            <div class="tab-icon-wrapper">
                                <div class="icon-with-badge">
                                    <div class="usdt-icon" :style="{ backgroundColor: method.iconColor }"><span >{{ method.icon }}</span></div>
                                    <div class="network-mini-badge" :class="method.badgeClass"><span >{{ method.badge }}</span></div>
                                </div>
                            </div>
                            <div class="tab-text-wrapper"><span class="tab-title">{{ method.title }}</span><span class="tab-network">{{ method.network }}</span></div>
                            <div class="tab-indicator" v-if="selectedMethod === method.id"></div>
                        </div>
                    </div>
                </div>
            </div>


            <!-- <div class="method-section">
                <div class="section-title">
                    <span class="title-text">{{ t('withdraw.method') }}</span>
                    <span class="title-subtitle">{{ t('withdraw.methodSubtitle') }}</span>
                </div>
                <div class="method-tabs">
                    <div class="method-tab" :class="{ 'active': selectedMethod === method.id }" v-for="method in withdrawMethods" :key="method.id" @click="selectMethod(method.id)">
                        <div class="tab-content">
                            <div class="tab-icon-wrapper">
                                <div class="icon-with-badge">
                                    <div class="usdt-icon" :style="{ backgroundColor: method.iconColor }"><span >{{ method.icon }}</span></div>
                                    <div class="network-mini-badge" :class="method.badgeClass"><span >{{ method.badge }}</span></div>
                                </div>
                            </div>
                            <div class="tab-text-wrapper"><span class="tab-title">{{ method.title }}</span><span class="tab-network">{{ method.network }}</span></div>
                            <div class="tab-indicator" v-if="selectedMethod === method.id"></div>
                        </div>
                    </div>
                </div>
            </div> -->


            <!-- <div class="bank-info-section">
                <div class="info-card">
                    <div class="card-header"><span class="card-title">{{ t('withdraw.bankInfo') }}</span></div>
                    <div class="info-item">
                        <div class="item-label"><span >{{ t('withdraw.bankName') }}</span></div>
                        <div class="item-value"><span >{{ bankInfo.bankName }}</span>
                        </div>
                    </div>
                    <div class="info-item">
                        <div class="item-label"><span >{{ t('withdraw.accountHolder') }}</span></div>
                        <div class="item-value"><span >{{ bankInfo.accountHolder }}</span>
                        </div>
                    </div>
                    <div class="info-item">
                        <div class="item-label"><span >{{ t('withdraw.bankCard') }}</span></div>
                        <div class="item-value"><span >{{ bankInfo.bankCard }}</span>
                        </div>
                    </div>
                </div>
            </div> -->


            <div class="crypto-section">
                <div class="input-card">
                    <div class="card-header">
                        <span class="card-title">{{ selectedMethodInfo.title }}</span>
                        <span class="card-subtitle">{{ selectedMethodInfo.subtitle }}</span>
                    </div>
                    <div class="input-container">
                        <input class="crypto-input" type="text" :placeholder="selectedMethodInfo.placeholder" v-model="walletAddress" readonly>
                    </div>
                </div>
            </div>


            <div class="amount-section">
                <div class="input-card">
                    <div class="card-header"><span class="card-title">{{ t('withdraw.amount') }}</span>
                        <span class="balance-info">{{ t('withdraw.balance') }} : {{ appConfig.currency.symbol }}{{ balance }}</span>
                    </div>
                    <div class="amount-input-container"><span class="currency-symbol">{{ appConfig.currency.symbol }}</span>
                        <input type="text" placeholder="0.00" class="amount-input" v-model="amount">
                    </div>
                    <div class="all-amount-btn" @click="withdrawAll"><span >{{ t('withdraw.withdrawAll') }}</span></div>
                </div>
            </div>

            <div class="password-section">
                <div class="input-card">
                    <div class="card-header"><span class="card-title">{{ t('withdraw.paymentPassword') }}</span></div>
                    <div class="input-container">
                        <input type="password" :placeholder="t('withdraw.passwordPlaceholder')" class="password-input" v-model="password">
                    </div>
                </div>
            </div>

            <div class="fee-section">
                <div class="fee-card">
                    <div class="fee-item"><span class="fee-label">{{ t('withdraw.principal') }}</span><span class="fee-value">{{ amount || '0' }} $</span></div>
                    <div class="fee-item"><span class="fee-label">{{ t('withdraw.serviceFee') }}</span><span class="fee-value">{{ serviceFee }} $</span></div>
                    <div class="fee-item total"><span class="fee-label">{{ t('withdraw.netAmount') }}</span><span class="fee-value">{{ netAmount }} $</span></div>
                </div>
            </div>

            <div class="notice-section">
                <div class="notice-card"><span class="notice-text">{{ t('withdraw.notice') }}</span></div>
            </div>

            <div class="bottom-action">
                <div class="submit-button" :class="{ disabled: isSubmitting }" @click="handleSubmit">
                    <span class="button-text">{{ isSubmitting ? t('common.submitting') : t('withdraw.withdrawButton') }}</span>
                    <span class="button-subtitle" v-if="amount && !isSubmitting">{{ t('withdraw.withdrawButton') }} ${{ netAmount }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { ElMessage } from 'element-plus'
import { appConfig } from '@/config/app'
import { getBankInfo, getUserInfo, withdraw } from '@/api'
import PageHeader from '@/components/PageHeader.vue'

import '@/assets/css/withdraw.css'


const router = useRouter()
const { t } = useI18n()

const bankInfo = ref({
  bankName: '',
  accountHolder: '',
  bankCard: ''
})

const isSubmitting = ref(false)

const fetchData = async () => {
  try {
    const [bankResponse, userResponse] = await Promise.all([
      getBankInfo(),
      getUserInfo()
    ])
    
    if (bankResponse.data.code === 200) {
      bankInfo.value.bankName = bankResponse.data.data.bankname || ''
      bankInfo.value.accountHolder = bankResponse.data.data.username || ''
      bankInfo.value.bankCard = bankResponse.data.data.cardnum || ''
      walletAddress.value = bankResponse.data.data.cardnum || ''
      
      const matchedMethod = withdrawMethods.find(m => m.badge === bankInfo.value.bankName)
      if (matchedMethod) {
        selectedMethod.value = matchedMethod.id
      }
    } else {
      router.push('/bind-usdt')
    }
    
    if (userResponse.data.code === 200) {
      balance.value = userResponse.data.data.balance || '0'
      serviceFeeRate.value = userResponse.data.data.withdraw_fee || 0.01
    }
  } catch (error) {
    console.error('获取信息失败:', error)
    router.push('/bind-usdt')
  }
}

onMounted(() => {
  window.scrollTo(0, 0)
  fetchData()
})

const amount = ref('')
const selectedMethod = ref('usdc')
const serviceFeeRate = ref(0.01)
const walletAddress = ref('')
const password = ref('')
const balance = ref('0')

const withdrawMethods = [
  {
    id: 'usdt_trc20',
    icon: '₮',
    iconColor: 'rgb(80, 175, 149)',
    badge: 'TRC20',
    badgeClass: 'trc-mini',
    title: 'USDT (TRC-20)',
    network: 'TRON Network'
  },
  {
    id: 'usdt_erc20',
    icon: '₮',
    iconColor: 'rgb(80, 175, 149)',
    badge: 'ERC20',
    badgeClass: 'erc-mini',
    title: 'USDT (ERC-20)',
    network: 'Ethereum Network'
  },
  {
    id: 'usdc',
    icon: '$',
    iconColor: 'rgb(39, 117, 202)',
    badge: 'ERC',
    badgeClass: 'erc-mini',
    title: 'USDC (ERC-20)',
    network: 'Ethereum Network'
  }
]

const currentWithdrawMethod = computed(() => {
  const matchedMethod = withdrawMethods.find(m => m.badge === bankInfo.value.bankName)
  return matchedMethod ? [matchedMethod] : []
})

const selectedMethodInfo = computed(() => {
  const method = currentWithdrawMethod.value.find(m => m.id === selectedMethod.value)
  if (!method) {
    return {
      title: t('withdraw.walletAddress'),
      subtitle: t('withdraw.walletAddressSubtitle'),
      placeholder: 'Enter wallet address'
    }
  }
  return {
    title: `${method.title} ${t('withdraw.walletAddress')}`,
    subtitle: `${t('withdraw.walletAddressSubtitle')} ${method.title}`,
    placeholder: `Enter address for ${method.title}`
  }
})

const serviceFee = computed(() => {
  if (!amount.value) return '0'
  const fee = parseFloat(amount.value) * serviceFeeRate.value
  return parseFloat(fee.toFixed(2)).toString()
})

const netAmount = computed(() => {
  if (!amount.value) return '0'
  const net = parseFloat(amount.value) - parseFloat(serviceFee.value)
  return parseFloat(net.toFixed(2)).toString()
})

const selectMethod = (id) => {
  selectedMethod.value = id
}

const withdrawAll = () => {
  amount.value = balance.value
}

const handleSubmit = async () => {
  if (isSubmitting.value) {
    return
  }
  
  if (!amount.value) {
    ElMessage.warning(t('withdraw.amount'))
    return
  }
  
  if (!password.value) {
    ElMessage.warning(t('withdraw.paymentPassword'))
    return
  }
  
  isSubmitting.value = true
  
  try {
    const response = await withdraw({
      paypassword: password.value,
      num: parseFloat(amount.value)
    })
    
    if (response.data.code === 200) {
      ElMessage.success(t('common.submitSuccess'))
      setTimeout(() => {
        router.push('/my')
      }, 2000)
    } else {
      ElMessage.error(response.data.msg || t('common.submitFailed'))
      isSubmitting.value = false
    }
  } catch (error) {
    console.error('提现失败:', error)
    ElMessage.error(t('common.submitFailed'))
    isSubmitting.value = false
  }
}
</script>

<style scoped>

</style>
